import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Pricing from "./pages/Pricing";
import Abonnemang from "./pages/Abonnemang";
import KomIgang from "./pages/KomIgang";
import Tack from "./pages/Tack";
import NotFound from "./pages/NotFound";
import Reklamfilm from "./pages/Reklamfilm";
import Videoavatarer from "./pages/Videoavatarer";
import ExplainerVideo from "./pages/ExplainerVideo";
import AnimatedFilm from "./pages/AnimatedFilm";
import OmOss from "./pages/OmOss";
import Contact from "./pages/Contact";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Kopvillkor from "./pages/Kopvillkor";
import Sitemap from "./pages/Sitemap";
import TestaFilmprojekt from "./pages/TestaFilmprojekt";

const App = () => (
  <LanguageProvider>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/abonnemang" element={<Abonnemang />} />
          <Route path="/kom-igang" element={<KomIgang />} />
          <Route path="/tack" element={<Tack />} />
          <Route path="/reklamfilm" element={<Reklamfilm />} />
          <Route path="/videoavatarer" element={<Videoavatarer />} />
          <Route path="/explainer-video" element={<ExplainerVideo />} />
          <Route path="/animerad-film" element={<AnimatedFilm />} />
          <Route path="/om-oss" element={<OmOss />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/kopvillkor" element={<Kopvillkor />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/testa-ditt-filmprojekt" element={<TestaFilmprojekt />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </LanguageProvider>
);

export default App;
